import { useEffect } from 'react';

interface JsonLdProps {
  id: string;
  data: Record<string, unknown>;
}

/**
 * Injects a <script type="application/ld+json"> tag into <head>.
 * Removed on unmount so route changes don't leak schema from other pages.
 */
const JsonLd = ({ id, data }: JsonLdProps) => {
  useEffect(() => {
    const tagId = `jsonld-${id}`;
    let script = document.getElementById(tagId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = tagId;
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(data);
    return () => {
      const el = document.getElementById(tagId);
      if (el) el.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;